import { DaoModel } from '@dynameat/models';

export class Event extends DaoModel {
  constructor(guid, name, description, eventTypeGuid, posGuidList, startDate, endDate,
    recurrent, typeOfRepetition, endCondition, recurrenceEndDate,
    numberOfRepetitions) {
    super(guid);
    this.name = name || '';
    this.description = description || '';
    this.eventTypeGuid = eventTypeGuid;
    this.posGuidList = posGuidList;
    this.startDate = startDate || '';
    this.endDate = endDate || '';
    this.recurrent = recurrent || false;
    this.typeOfRepetition = typeOfRepetition || '';
    this.endCondition = endCondition || '';
    this.recurrenceEndDate = recurrenceEndDate || null;
    this.numberOfRepetitions = numberOfRepetitions || 0;
  }

  static toInstance(props = {}) {
    return new Event(props.guid, props.name, props.description, props.event_type,
      props.points_of_sale, props.start_date, props.end_date, props.recurrent,
      props.type_of_repetition, props.end_condition, props.recurrence_end_date,
      props.number_of_repetitions);
  }

  serialize() {
    return {
      guid: this.guid,
      name: this.name,
      description: this.description,
      event_type: this.eventTypeGuid,
      points_of_sale: this.posGuidList,
      start_date: this.startDate,
      end_date: this.endDate,
      recurrent: this.recurrent,
      type_of_repetition: this.typeOfRepetition,
      end_condition: this.endCondition,
      recurrence_end_date: this.recurrenceEndDate,
      number_of_repetitions: this.numberOfRepetitions
    };
  }
}
